import { epicRequest } from 'app'

export const PLAYER_PAGE_FETCH = 'PLAYER_PAGE_FETCH'
export const PLAYER_PAGE_FETCH_ERROR = 'PLAYER_PAGE_FETCH_ERROR'
export const PLAYER_PAGE_FETCH_FULFILLED = 'PLAYER_PAGE_FETCH_FULFILLED'
export const PLAYER_PAGE_FETCH_CANCELED = 'PLAYER_PAGE_FETCH_CANCELED'

export const PLAYER_PAGE_INITIAL_STATE = {
  data: [],
  error: null,
  pagination: null,
}

export const playerFetch = (playerId) => ({
  payload: {
    playerId,
  },
  type: PLAYER_PAGE_FETCH,
})

export const playerFetchFulfilled = (payload) => ({
  payload,
  type: PLAYER_PAGE_FETCH_FULFILLED,
})

export const playerFetchError = (payload) => ({
  payload,
  type: PLAYER_PAGE_FETCH_ERROR,
})

export const playerFetchCanceled = () => ({
  payload: null,
  type: PLAYER_PAGE_FETCH_CANCELED,
})

export const playerPageFetchEpic = epicRequest({
  actionType: PLAYER_PAGE_FETCH,
  errorAction: playerFetchError,
  fulfilledAction: playerFetchFulfilled,
  request: ({ payload }) => `users/player/${payload.playerId}/summary`,
  untilTypes: PLAYER_PAGE_FETCH_CANCELED,
})
